// extracted by mini-css-extract-plugin
export default {"ohlcContainer":"marketwatch_ohlcContainer__Cgdcx","mw__pane":"marketwatch_mw__pane__kSyP3"};